import { Input } from "@/components/ui/input"
import { Checkbox } from "@/components/ui/checkbox"
import { ValidationError } from "../form/ValidationError"
import { Info } from "lucide-react"

interface MailSenderInfoProps {
  formData: {
    firstName: string
    lastName: string
    email: string
    isAnonymous?: boolean
  }
  handleInputChange: (field: string, value: string) => void
  showErrors: boolean
}

export function MailSenderInfoStep({ formData, handleInputChange, showErrors }: MailSenderInfoProps) {
  const isAnonymous = !!formData.isAnonymous

  return (
    <div className="space-y-4">
      <div className="flex items-start space-x-3 p-4 bg-muted/50 rounded-lg border border-border">
        <Checkbox
          id="isAnonymous"
          checked={isAnonymous}
          onCheckedChange={(checked) => {
            handleInputChange("isAnonymous", checked ? "true" : "")
            if (checked) {
              handleInputChange("firstName", "")
              handleInputChange("lastName", "")
            }
          }}
        />
        <div className="flex-1 space-y-1">
          <label htmlFor="isAnonymous" className="block text-sm font-semibold cursor-pointer text-[#18375d]">
            Send Anonymously
          </label>
          <div className="flex items-start gap-2 text-sm text-muted-foreground">
            <Info className="w-4 h-4 mt-0.5 flex-shrink-0" />
            <p>
              Your information will not be shared or disclosed by Desistit or included in the body of the letter.
            </p>
          </div>
        </div>
      </div>

      {!isAnonymous && (
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1 text-[#18375d]">
              First Name <span className="text-[#ea384c]">*</span>
            </label>
            <Input
              value={formData.firstName}
              onChange={(e) => handleInputChange("firstName", e.target.value)}
              placeholder="First Name"
              className={showErrors && !formData.firstName ? "border-[#ea384c]" : ""}
            />
            {showErrors && !formData.firstName && (
              <ValidationError message="First name cannot be blank" />
            )}
          </div>
          <div>
            <label className="block text-sm font-medium mb-1 text-[#18375d]">
              Last Name <span className="text-[#ea384c]">*</span>
            </label>
            <Input
              value={formData.lastName}
              onChange={(e) => handleInputChange("lastName", e.target.value)}
              placeholder="Last Name"
              className={showErrors && !formData.lastName ? "border-[#ea384c]" : ""}
            />
            {showErrors && !formData.lastName && (
              <ValidationError message="Last name cannot be blank" />
            )}
          </div>
        </div>
      )}

      <div>
        <label className="block text-sm font-medium mb-1 text-[#18375d]">
          Email <span className="text-[#ea384c]">*</span>
        </label>
        <Input
          type="email"
          value={formData.email}
          onChange={(e) => handleInputChange("email", e.target.value)}
          placeholder="Email Address"
          className={showErrors && !formData.email ? "border-[#ea384c]" : ""}
        />
        {showErrors && !formData.email && (
          <ValidationError message="Email cannot be blank" />
        )}
      </div>
    </div>
  )
}
